// Runtime config for the StrayCatBlues SPA.
//
// Same-origin in production: the deployed SPA sits behind the edge Caddy, which
// reverse-proxies /auth/* and /v1/* to the Nexus kstack-dev instance on the same
// origin (straycatblues-dev.kstack.app). Same-origin = no CORS. Local dev can set
// VITE_GATEWAY_BASE; vite.config also proxies /v1 and /auth to dev.

export const APP_ID = 'straycatblues' as const;

export const GATEWAY_BASE: string =
  (import.meta.env.VITE_GATEWAY_BASE as string | undefined)?.replace(/\/+$/, '') ?? '';

export function appFnUrl(name: string): string {
  return `${GATEWAY_BASE}/v1/app/${APP_ID}/fn/${name}`;
}

// Org's official horizontal navy logo (their CDN). Falls back to a wordmark if it
// fails to load.
export const LOGO_URL =
  'https://images.squarespace-cdn.com/content/v1/6223fca92aea2a75f0d692b5/f8242dda-6ec8-438f-a668-b312f15ebc46/Navy_Logo_Horiz.png?format=750w';
